import { effect, runInInjectionContext } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { CookieConsentService } from './app/services/cookie-consent.service';

interface WindowWithGtag extends Window {
  dataLayer?: unknown[];
  gtag?: (...args: unknown[]) => void;
}

function loadGoogleAnalytics(): void {
  if (!environment.googleAnalyticsId) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
  document.head.appendChild(script);

  const win = window as unknown as WindowWithGtag;
  win.dataLayer = win.dataLayer || [];
  win.gtag = function gtag(...args: unknown[]) {
    win.dataLayer?.push(args);
  };
  win.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'granted',
  });
  win.gtag('js', new Date());
  win.gtag('config', environment.googleAnalyticsId);
}

function updateAnalyticsConsent(granted: boolean): void {
  const win = window as unknown as WindowWithGtag;
  win.gtag?.('consent', 'update', {
    analytics_storage: granted ? 'granted' : 'denied',
  });
}

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    runInInjectionContext(appRef.injector, () => {
      const cookieConsentService = appRef.injector.get(CookieConsentService);
      let analyticsLoaded = false;

      effect(() => {
        const granted = cookieConsentService.analyticsGranted();
        if (granted && !analyticsLoaded) {
          analyticsLoaded = true;
          loadGoogleAnalytics();
        } else if (analyticsLoaded) {
          updateAnalyticsConsent(granted);
        }
      });
    });
  })
  .catch((err) => console.error(err));
